export const CINDescriptionCodeSituation = {
	codSituation1: '1 - PROCESSO INICIADO',
	codSituation2: '2 - PROCESSO AUTORIZADO',
	codSituation3: '3 - PROCESSO CONCLUÍDO',
	codSituation4: '4 - PROCESSO CANCELADO',
};

export const CINValidationMessages = {
	ufDifferentSP:
		'Emissão de CIN não poderá ser realizada no Estado de São Paulo. CPF está em atendimento CIN em outro estado da federação',
	ufAttendancySP:
		'Emissão da CIN não poderá ser realizada neste momento no estado de São Paulo. Cidadão com processo de emissão iniciado anteriormente',
};
